








import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = 'HHHB0720';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动规则',
      path: `/${baseUrl}/rule`,
      id: 1,
    },
    {
      title: '作品展示',
      path: `/${baseUrl}/home`,
      id: 2,
    },
    {
      title: '上传作品',
      path: `/${baseUrl}/save`,
      id: 3,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  changeRoute() {
    if (
      this.$route.path.indexOf('home') > -1 ||
      this.$route.path.indexOf('detail') > -1 ||
      this.$route.path.indexOf('user') > -1
    ) {
      this.activeTab = 1;
    } else if (this.$route.path.indexOf('rule') > -1) {
      this.activeTab = 0;
    } else if (this.$route.path.indexOf('save') > -1) {
      this.activeTab = 2;
    }
  }
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/d/file/image/default/2023-07-24/d06a116f9ee1d726906060aafd6a9e3d.png';
    // App分享
    this.$appShareInfo({
      title: '重庆市青少年知识产权绘画海报创意大赛',
      url: location.href,
      subtitle: `重庆市青少年知识产权绘画海报创意大赛`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '重庆市青少年知识产权绘画海报创意大赛',
        subtitle: `重庆市青少年知识产权绘画海报创意大赛`,
        image: cover,
      });
    }
  }
  async created() {
    const unionid = window.localStorage.getItem('unionid');
    if (isWeiXin() && !unionid) {
      this.weiXinLogin();
    }
    if (!window.udid) {
      return;
    }
    const token = window.gettoken();
    if (window.udid && (token === 'null' || !token)) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
    }
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
  weiXinLogin() {
    const appId = 'wx1949ed4a473b87ed';
    location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
      location.href,
    )}`;
  }
}
